var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFourCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32.1334C26.7012 32.1334 32.1334 26.7012 32.1334 20C32.1334 13.299 26.7012 7.8667 20 7.8667C13.299 7.8667 7.8667 13.299 7.8667 20C7.8667 26.7012 13.299 32.1334 20 32.1334Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 20.4667C14.1423 20.4667 13.9333 20.2577 13.9333 20C13.9333 19.7423 14.1423 19.5333 14.4 19.5333",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 20.4667C14.6576 20.4667 14.8666 20.2577 14.8666 20C14.8666 19.7423 14.6576 19.5333 14.3999 19.5333",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 20.4667C19.7424 20.4667 19.5334 20.2577 19.5334 20C19.5334 19.7423 19.7424 19.5333 20.0001 19.5333",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.4667C20.2577 20.4667 20.4667 20.2577 20.4667 20C20.4667 19.7423 20.2577 19.5333 20 19.5333",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 20.4667C25.3422 20.4667 25.1333 20.2577 25.1333 20C25.1333 19.7423 25.3422 19.5333 25.6 19.5333",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5999 20.4667C25.8576 20.4667 26.0665 20.2577 26.0665 20C26.0665 19.7423 25.8576 19.5333 25.5999 19.5333",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFourCircleOutline);
export default __webpack_public_path__ + "static/media/icon_four_circle_outline.d6f7a411f56340a3c6ade213e80104e1.svg";
export { ForwardRef as ReactComponent };